module.exports = __webpack_public_path__ + "img/5-copia-1536x864.3ba3206a.png";